import React from "react";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles(
  () => ({
    root: {
      display: "flex",
      flexGrow: 1,
      flexWrap: "wrap",
      margin: 10
    },
    stepHeading: { color: "#C51344", width: "100%", fontWeight: "bold" },
    nextStepHeading: { width: "100%" }
  }),
  { name: "StepperHeading" }
);

export function StepperHeading(props) {
  const { stepHeading = "Lorem Ipsum", nextStepHeading, currentPage } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography className={classes.stepHeading} align={"right"} variant={"body1"}>
        {stepHeading} {stepHeading === "3D Modell" ? "" : " wählen"}
      </Typography>
      {nextStepHeading && (
        <Typography className={classes.nextStepHeading} align={"right"} variant={"body2"} color={"textSecondary"}>
          Nächster Schritt: {nextStepHeading}
        </Typography>
      )}
      {currentPage === 4 && (
        <Typography className={classes.nextStepHeading} align={"right"} variant={"body2"} color={"textSecondary"}>
          Nächster Schritt: Kontakt aufnehmen
        </Typography>
      )}
    </div>
  );
}
